import React, { useEffect } from 'react';
import ConfirmEmailWithCode from 'components/ConfirmEmailWithCode.jsx';

// Full-screen, undismissible gate shown to a signed-in but unconfirmed user when
// STOP_UNCONFIRMED_USERS_FROM_BROWSING is enabled (see ApplicationController
// #force_email_confirmation? and shared/_force_confirm_email). There is no close
// affordance and the fixed overlay covers the whole page, so the user cannot
// interact with anything behind it — they must enter the emailed code to
// continue. On the correct code the page reloads and the now-confirmed user gets
// the normal site.
const OVERLAY = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100000,
  background: 'rgba(0, 0, 0, 0.6)', display: 'flex',
  alignItems: 'center', justifyContent: 'center', padding: '16px'
};

const CARD = {
  background: '#fff', borderRadius: '12px', padding: '32px 28px 26px',
  width: '460px', maxWidth: '100%', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.25)'
};

const ForceConfirmEmail = ({ email }) => {
  // Lock page scroll while the gate is up so the user cannot scroll the site
  // behind the overlay, and record that the gate was shown (registered in
  // GENERIC_EVENTS as 'force_confirm_email_shown').
  useEffect(() => {
    if (typeof trackEvent === 'function') {
      trackEvent('force_confirm_email_shown', {});
    }

    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, []);

  return (
    <div style={OVERLAY} role="dialog" aria-modal="true">
      <div style={CARD}>
        <ConfirmEmailWithCode email={email} onConfirmed={() => window.location.reload()} />
      </div>
    </div>
  );
};

export default ForceConfirmEmail;
